import {Report} from "../models";

export class FetchReports {
  static readonly type = '[Reports] Fetch';

  constructor() {
  }
}

export class FetchYears {
  static readonly type = '[Reports] Years';

  constructor() {
  }
}


export class AddReport {

  static readonly type = '[Reports] Add';

  constructor(public payload: any) {
  }
}


export class DeleteReport {

  static readonly type = '[Reports] Delete';

  constructor(public report: Report) {
  }
}

